import { render, staticRenderFns } from "./ManageFeatureEvent.vue?vue&type=template&id=66610234&scoped=true&"
import script from "./ManageFeatureEvent.vue?vue&type=script&lang=js&"
export * from "./ManageFeatureEvent.vue?vue&type=script&lang=js&"
import style0 from "./ManageFeatureEvent.vue?vue&type=style&index=0&id=66610234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66610234",
  null
  
)

export default component.exports